import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChatMessage from '../ChatMessage';
import KtmbDelays from './KtmbDelays';
import ReactMarkdown from 'react-markdown';
import {
  faArrowUp,
  faVolumeUp,
  faVolumeMute
} from '@fortawesome/free-solid-svg-icons';
import './ktmbAiAgent.css';
import userProfileService from '../services/UserProfileService';
import LangflowApiService from '../services/LangflowApiService';
import KtmbTimetable from './KtmbTimetable';
import VoiceHelper from '../VoiceHelper';
//no longer in use , keep in for future reference
const KtmbAiAgent = ({ktmbDelayInfo}) => {
  // Ensure ASO banner script runs after mount so the zone is filled
  useEffect(() => {
    if (!window.__asoBannerLoaded) {
      const s = document.createElement('script');
      s.src = 'https://media.aso1.net/js/code.min.js';
      s.async = true;
      s.onload = () => window._aso?.refresh?.();
      document.body.appendChild(s);
      window.__asoBannerLoaded = true;
    } else {
      window._aso?.refresh?.();
    }
  }, []);
  
  const [suggestedText, setSuggestedText] = useState('');
  const [messages, setMessages] = useState([]);
  const chatBoxRef = useRef(null);
  const endOfMessagesRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showMapOverlay, setShowMapOverlay] = useState(false);
  const [showBlogOverlay, setShowBlogOverlay] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [hasSentWelcome, setHasSentWelcome] = useState(false);
  // Voice reply toggle state
  const [voiceReplyEnabled, setVoiceReplyEnabled] = useState(false);
  const [sessionId] = useState(userProfileService.getSessionId());
  const [profile] = useState(JSON.parse(userProfileService.getProfile()));
  const [showTimetableOverlay, setShowTimetableOverlay] = useState(false);
  // Use useLayoutEffect for immediate scroll after render

  useLayoutEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);


  useEffect(() => {

    setTimeout(() => {
      // if (profile) {
      //   LangflowApiService.sendMessage(
      //     'my personal profile -' + JSON.stringify(profile),
      //     sessionId,
      //     process.env.REACT_APP_LANGFLOW_KTMB_AI_FLOW_ID
      //   );
      // }
    
    }, 0);
  }, []);


  const handleSendMessage = async (text) => {
    if (!text.trim()) return;

    // Mark that user has interacted
    setHasUserInteracted(true);
    setShowOverlay(false);
    setShowMapOverlay(false);
    setShowBlogOverlay(false);

    const userMsg = {
      id: Date.now() + '-user',
      sender: 'user',
      text: text,
      loading: false,
    };

    const loadingMsg = {
      id: Date.now() + '-bot',
      sender: 'bot',
      text: '...',
      loading: true,
    };

    const newMessages = [...messages, userMsg, loadingMsg];
    setMessages(newMessages);
    setInputValue('');

    try {
      const data = await LangflowApiService.sendMessage(
        text,
        userProfileService.getSessionId(),
        process.env.REACT_APP_LANGFLOW_KTMB_AI_FLOW_ID
      );
      const { text: responseText, travelFrom, travelTo, travelOptions, ktmbTimetable, departureTime } =
        LangflowApiService.parseResponse(data);

      const botMsg = {
        id: loadingMsg.id,
        sender: 'bot',
        text: responseText ?? '[No reply]',
        travelFrom, 
        travelTo,
        travelOptions,
        ktmbTimetable,  
        departureTime,
        loading: false,
        showCarousel: false,
      };

      const updatedMessages = newMessages.map((msg) =>
        msg.id === loadingMsg.id ? botMsg : msg
      );

      setMessages(updatedMessages);

      // Speak the bot message if voice reply is enabled
      if (voiceReplyEnabled && responseText?.trim()) {
        VoiceHelper.speakText(responseText);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMsg = {
        id: loadingMsg.id,
        sender: 'bot',
        text: '[Error fetching response]',
        loading: false,
      };
      setMessages(
        newMessages.map((msg) =>
          msg.id === loadingMsg.id ? errorMsg : msg
        )
      );
    }
  };

  const handleInputFocus = () => {
    setTimeout(() => {
      if (chatBoxRef.current) {
        chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
      }
    }, 300);
  };

  
  const [inputValue, setInputValue] = useState('');

  // Use useLayoutEffect for immediate scroll after render
  useLayoutEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);


  return (
    <div className="ktmbaichat-container">
      {/* Floating speaker toggle button */}
      <div className="fab-container" style={{ pointerEvents: 'auto', marginTop: '7%'}}>
        <button
          className={`fab-action-btn${voiceReplyEnabled ? ' active' : ''}`}
          onClick={() => setVoiceReplyEnabled(prev => !prev)}
          title={voiceReplyEnabled ? 'Disable Voice Reply' : 'Enable Voice Reply'}
        >
          <FontAwesomeIcon icon={voiceReplyEnabled ? faVolumeUp : faVolumeMute} className="fab-speaker-icon" />
        </button>
      </div>
      <div className="ktmb-header">
        {/* <div className="ktmb-logo"></div> */}
        <div className="ktmb-title">🚄 KTMB AI Agent</div>
        {/* <div className="ktmb-subtitle">Malaysia Railways Virtual Assistant</div> */}
      </div>
      <div className="chatbot-scrollable">
        {/* Greeting and Location */}
        {/* <div className="greeting-section">
          <div className="greeting-name">Hello, {userProfile?.firstName || 'Loading...'}</div>
          <div className="greeting-help">How can I help?</div>
          <div className="greeting-location">
            <span className="location-icon"><FontAwesomeIcon icon={faLocationDot} /></span>
            {locationLabel || 'Unknown location'}
          </div>
        </div> */}

        {/* Info Cards - Vertical Stack */}
        <KtmbDelays/>
        <div className="info-cards-container">

        {/* Service Updates Card */}
        {/* <div className="ktmb-service-card">
          <div className="ktmb-service-card-icon">
            <span>🔔</span>
          </div>
          <div className="ktmb-service-card-title">Service Updates</div>
          <div className="ktmb-service-card-desc">Get real-time updates on delays, disruptions, or service changes across the network.</div>
        </div> */}
        
        {/* Train Schedule Card */}

       
        <div className="ktmb-schedule-card" onClick={() => setShowTimetableOverlay(true)} style={{ cursor: 'pointer' }}>
          <div className="ktmb-schedule-card-icon">
            <span>🚆</span>
          </div>
          <div className="ktmb-schedule-card-title">KTMB Schedule</div>
          <div className="ktmb-schedule-card-desc">Plan your journey and get your ticket in one click.</div>
        </div>
      {showTimetableOverlay && (
        <div className="ktmb-timetable-modal-overlay">
          <div className="ktmb-timetable-modal-content">
            <button
              onClick={() => setShowTimetableOverlay(false)}
              className="ktmb-timetable-modal-close"
              aria-label="Close timetable"
            >
              ✕
            </button>
            <KtmbTimetable />
          </div>
        </div>
      )}
        </div>

  

       
        <div ref={chatBoxRef} className="chatbox">

        <div className='message-row bot'>
          <div className='message-bubble bot'>
            <div className='message-text'>
              👋 Hey {profile.firstName}! I’m the KTMB AI Agent 🤖 – ready to help you check train schedules, routes, and more. 🚄 Let’s get you moving!
            </div>
          </div>
        </div>
        <div className="quick-actions">
          <button
            className='quick-action-button'
            onClick={() => {
              setHasUserInteracted(true);
              setInputValue('KTMB Train Timetable from to');
              setSuggestedText('KTMB Train Timetable from to');
            }}
          >
            KTMB Train Timetable from to
          </button>
          <button
            className='quick-action-button'
            onClick={() => {
              setHasUserInteracted(true);
              setInputValue('Train Schedule from  to  on coming Friday');
              setSuggestedText('Train Schedule from .. to .. on coming Friday');
            }}
          >
            Train Schedule from .. to .. on coming Friday
          </button>
          <button
            className='quick-action-button'
            onClick={() => {
              setHasUserInteracted(true);
              setInputValue('Train schedule from .. to .. for tomorrow');
              setSuggestedText('Train schedule from  to  for tomorrow.');
            }}
          >
            Train schedule from .. to .. for tomorrow
          </button>
     
          <button
            className='quick-action-button'
            onClick={() => {
              setHasUserInteracted(true);
              setInputValue('Next train from to');
              setSuggestedText('Next train from to');
            }}
          >
            Next train from to
          </button>

        </div>
         
          {messages
            .map((msg) => (
              <ChatMessage
                key={msg.id}
                sender={msg.sender}
                text={msg.text}
                loading={msg.loading}
                travelFrom={msg.travelFrom}
                travelTo={msg.travelTo}
                travelOptions={msg.travelOptions}
                ktmbTimetable={msg.ktmbTimetable}
                departureTime={msg.departureTime}
                showOverlay={showOverlay}
                setShowOverlay={setShowOverlay}
                showMapOverlay={showMapOverlay}
                setShowMapOverlay={setShowMapOverlay}
                showBlogOverlay={showBlogOverlay}
                setShowBlogOverlay={setShowBlogOverlay}
              />
            ))}
          <div ref={endOfMessagesRef} />
        </div>

        {/* Suggested Text Display */}
        {suggestedText && (
          <div style={{
            margin: '0 auto 0.5rem auto',
            maxWidth: 480,
            background: '#fff',
            color: '#2469ec',
            borderRadius: 16,
            padding: '0.6rem 1rem',
            fontWeight: 500,
            fontSize: '1.05rem',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            letterSpacing: 0.1,
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}>
            <span style={{marginRight: 6, fontSize: 18}}>💡</span>
            <span>{suggestedText}</span>
            <button
              style={{
                marginLeft: 'auto',
                background: 'none',
                border: 'none',
                color: '#aaa',
                fontSize: 18,
                cursor: 'pointer',
                padding: 0
              }}
              onClick={() => setSuggestedText('')}
              title="Clear suggestion"
            >
              ×
            </button>
          </div>
        )}
      </div>
      <div className="input-container">
        {/* Error messages are disabled */}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            if (suggestedText && e.target.value !== suggestedText) setSuggestedText('');
          }}
          onKeyDown={(e) => e.key === 'Enter' && handleSendMessage(inputValue)}
          onFocus={handleInputFocus}
          placeholder={'Type something '}
          className="chat-input"
        />
       
        <button
          onClick={() => {
            setHasUserInteracted(true);
            handleSendMessage(inputValue);
          }}
          className="send-button"
          disabled={!inputValue.trim()}
        >
          
            <FontAwesomeIcon icon={faArrowUp} />
          
        </button>
      </div>

  
    </div>
  );
};

export default KtmbAiAgent;
